<template>
  <div id="messages-list" class="messages-list-container">

    <setting-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      :message="sidebarData"
      @closeSidebar="toggleDataSidebar"
      @updateMessages="fetchMessages"
    />

    <vs-table
      search
      ref="table"
      :sst="true"
      :data="messages"
      :max-items="100"
      noDataText="Sem dados disponíveis"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center" v-if="canSee('nps')">
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click.stop="newMessage">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Nova Avaliação</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Título</vs-th>
        <vs-th sort-key="number" style="width: 10vw" class="text-center">Ordem das Avaliações</vs-th>
        <vs-th class="flex justify-content-center">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name  }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium text-center">{{ tr.number || 0 }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap text-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                v-if="canSee('nps')"
                @click.stop="editData(tr)"
              />
              <feather-icon
                class="ml-3"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                v-if="canSee('nps') && tr.from_mutation"
                @click.stop="confirmToDelete(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import SettingViewSidebar from '@/views/messages/MessageNPSViewSidebar'
import requests from '@/http/requests/messages'
import {hasPermission} from '@/utils'

export default {
  name: 'message-settings',
  components: { SettingViewSidebar },
  data() {
    return {
      messages: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {
      this.sidebarData = this.$_.cloneDeep(data)
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    canSee(action) {
      return hasPermission(`settings-messages-${action}`)
    },
    newMessage() {
      this.sidebarData = {
        id: null,
        tag: 'nps_message',
        name: '',
        value: '',
        parent_id: '2',
        from_mutation: true,
        number: this.messages.length,
        scale: { start: '1', end: '10' }
      }
      this.toggleDataSidebar(true)
    },
    fetchMessages() {
      this.messages = [];
      this.$store.dispatch('setShowLoadingOverlay', true)

      requests.fetch({ tag: 'nps_message', from_mutation: true }).then((response) => {
        this.messages = response.data.data.messages;
        this.$store.dispatch('setShowLoadingOverlay', false)
      }).catch((error) => {
        this.$store.dispatch('setShowLoadingOverlay', false)
        console.error(error)
      })
    },
    confirmToDelete(data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Você realmente deseja fazer isso?`,
        text: `Será removida o tipo de avaliação '${data.name}'.`,
        acceptText: 'Deletar',
        cancelText: 'Voltar',
        accept: () => this.deleteData(data)
      });
    },
    deleteData(data) {
      this.$store.dispatch('setShowLoadingOverlay', true)
      requests.delete(data.id).then(() => {
        this.$store.dispatch('setShowLoadingOverlay', false)
        this.fetchMessages();
        this.$vs.notify({
          title: "Sucesso",
          color: "success",
          text: "Avaliação deletada com sucesso"
        });
      }).catch((error) => {
        this.$store.dispatch('setShowLoadingOverlay', false)
        console.error(error)
      })
    }
  },
  created() {
    this.fetchMessages()
  },
  beforeRouteLeave(to, from, next) {
    if (this.addNewDataSidebar) {
      this.addNewDataSidebar = false;
      setTimeout(() => {
        next();
      }, 2);
    } else {
      next();
    }
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#messages-list {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
